<template>
	<div class="offers-subview">
		<div class="subviewOpts">
			<it-link :to="createOfferLink" class="button-link button-link-bicon"><sym-icon name="offer"></sym-icon> {{ env.msg('menu.addOffer') }}</it-link>
		</div>

		<div id="offersSubview">
			<crm-table :rest-api="restApi"></crm-table>
		</div>
	</div>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import {injectEnv} from "@fd/Environment.ts";
import {addContextParams, ContextKey, getIntValue, injectContext, OFFER_REFS, OPPORTUNITY_REFS} from "@t/fd/AppContext.ts";
import CrmTable from "@/vue/table/CrmTable.vue";
import SymIcon from "@fd/helpers/SymIcon.vue";
import ItLink from "@/router/ItLink.vue";

const env = injectEnv();
const ctx = injectContext();
const sourceType = computed<number>(() => getIntValue(ctx.value, ContextKey.SRC_TYPE));
const sourceId = computed<string|number>(() => getIntValue(ctx.value, ContextKey.SRC_ID));

const restApi = computed<string>(() => {
	let ep = "api/offers/agendaSubview";
	ep = env.net.urlParam(ep, "srcType", sourceType.value);
	ep = env.net.urlParam(ep, "srcId", sourceId.value);
	return ep;
});

const createOfferLink = computed<string>(() => {
	let link = addContextParams('createOffer.do', ctx.value, OFFER_REFS);
	return link;
});</script>

<style>

</style>